import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"margin":"0 0 20px"} }

import policyDialog from "./policyDialog.vue"
import privacyDialog from "./privacyDialog.vue"
import { ref, reactive, onMounted } from 'vue';
import { register, sendCode, getCaptcha } from "@/api/common.js"
import { ElMessage } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'registerDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    }
},
  emits: ['close', 'registerClose'],
  setup(__props, { emit: __emit }) {

const props = __props
const dialogShow = ref(props.popupShow)
const loginRef = ref()
const formData = ref({
    phone: '',
    code: '',
    password: '',
    flag: false,
    imgcode: ''
})
const policyShow = ref(false)
const privacyShow = ref(false)
const codeTime = ref(0)
let codeTimer = null
const loginCodeImg = ref()
let nowUuid = ''
const gradeList = ['三年级',
    '四年级',
    '五年级',
    '六年级',
    '初一',
    '初二',
    '初三'
]

const emitList = __emit
const formRules = {
    phone: [
        {
            message: '请输入手机号',
            required: true
        }
    ],
    password: [
        {
            message: '请输入密码',
            required: true
        }
    ],
    code: [
        {
            message: '请输入验证码',
            required: true
        }
    ],
    imgcode: [
        {
            message: '请输入图形验证码',
            validator: (rule: any, value: any, callback: any) => {
                if (!value) {
                    callback(new Error("请输入图形验证码"))
                }
                callback()
            }
        }
    ],
    // grade: [
    //     {
    //         message: '请选择年级',
    //         required: true
    //     }
    // ]
}

function registerEvent() {
    loginRef.value.validate(valid => {
        if (valid) {
            if (!formData.value.flag) {
                return ElMessage.warning('请先阅读用户协议和隐私政策');
            }
            const params = {
                ...formData.value
            }
            console.log(params)
            register(params).then(res => {
                console.log(res)
                sessionStorage.setItem('token', res.data.jwt)
                emitList('registerClose')
            }).catch(err => {
                console.log(err)
            })
        }
    })
}

function closeEvent() {
    emitList('close')
}

function getCode() {
    if (codeTime.value > 0) {
        return ElMessage.warning('倒计时结束后再发送')
    } else {
        loginRef.value.validateField(['phone', 'imgcode'], valid => {
            if (valid) {
                const params = {
                    phone: formData.value.phone,
                    type: '02',
                    uuid: nowUuid
                }
                console.log(params)
                sendCode(params).then(res => {
                    ElMessage.success('验证码已发送')
                    codeTime.value = 60
                    codeTimer = setInterval(() => {
                        if (!codeTime.value) {
                            clearInterval(codeTimer)
                            codeTimer = null
                        } else {
                            codeTime.value--;
                        }
                    }, 1000)
                }).catch(err => {
                    console.log(err)
                })
            }
        })
    }
}
function getImgCode() {
    const randomNum = Math.floor(Math.random() * (99999999 - 10000000 + 1)) + 10000000;
    const uuid = `${randomNum}-${new Date().getTime()}`
    getCaptcha({
        uuid: uuid
    }).then(res => {
        loginCodeImg.value = 'data:image/png;base64,' + res.data;
        nowUuid = uuid
    })
}
onMounted(() => {
    getImgCode()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogShow).value = $event)),
    width: "400px",
    center: "",
    onClose: closeEvent,
    "modal-class": "dialog-new-model"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "login-title" }, [
          _createTextVNode("HELLO,欢迎注册 "),
          _createElementVNode("span", { class: "activeColor" }, "开悟作文")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref_key: "loginRef",
            ref: loginRef,
            model: formData.value,
            rules: formRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "phone" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.phone,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.phone) = $event)),
                            placeholder: "请输入手机号"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "imgcode" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.imgcode,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.imgcode) = $event)),
                            placeholder: "请输入图形验证码"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      (loginCodeImg.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "loginCodeImg",
                            onClick: getImgCode
                          }, [
                            _createElementVNode("img", { src: loginCodeImg.value }, null, 8, _hoisted_3)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "code" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.code,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.code) = $event)),
                            placeholder: "请输入验证码"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        color: "#ef8b25",
                        plain: "",
                        onClick: getCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(codeTime.value?`${codeTime.value}秒重新获取`:'获取验证码'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "password" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.password,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.password) = $event)),
                            placeholder: "请输入密码",
                            type: "password",
                            "show-password": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_checkbox, {
            modelValue: formData.value.flag,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.flag) = $event))
          }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createTextVNode(" 我已阅读并同意 ")),
              _createElementVNode("span", {
                class: "activeColor",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (policyShow.value=true), ["stop"]))
              }, "《用户协议》"),
              _cache[11] || (_cache[11] = _createTextVNode("和 ")),
              _createElementVNode("span", {
                class: "activeColor",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (privacyShow.value=true), ["stop"]))
              }, "《隐私政策》")
            ]),
            _: 1,
            __: [10,11]
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            style: {"width":"100%"},
            color: "#ef8b25",
            class: "footer-btn1",
            onClick: registerEvent
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("立即注册")
            ])),
            _: 1,
            __: [12]
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_divider, null, {
            default: _withCtx(() => [
              _createElementVNode("span", { style: {"font-size":"12px"} }, [
                _cache[13] || (_cache[13] = _createTextVNode("我已注册！ ")),
                _createElementVNode("span", {
                  class: "activeColor",
                  style: {"cursor":"pointer"},
                  onClick: closeEvent
                }, "返回登陆")
              ])
            ]),
            _: 1
          })
        ])
      ]),
      (policyShow.value)
        ? (_openBlock(), _createBlock(policyDialog, {
            key: 0,
            popupShow: policyShow.value,
            onClose: _cache[7] || (_cache[7] = ($event: any) => (policyShow.value=false))
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true),
      (privacyShow.value)
        ? (_openBlock(), _createBlock(privacyDialog, {
            key: 1,
            popupShow: privacyShow.value,
            onClose: _cache[8] || (_cache[8] = ($event: any) => (privacyShow.value=false))
          }, null, 8, ["popupShow"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})